module.exports = __webpack_public_path__ + "images/fa5cdd9ad950fffd71c051a25bc2dfa7-illu_dir_glass1.svg";